import { parseAbi } from "viem";

// ============================================
// Generic ERC20 ABI (for any ERC20 token)
// ============================================
export const erc20ABI = parseAbi([
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function decimals() view returns (uint8)",
  "function totalSupply() view returns (uint256)",
  "function balanceOf(address account) view returns (uint256)",
  "function transfer(address to, uint256 amount) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function transferFrom(address from, address to, uint256 amount) returns (bool)",
  "event Approval(address indexed owner, address indexed spender, uint256 value)",
  "event Transfer(address indexed from, address indexed to, uint256 value)",
]);

// ============================================
// MBC Token ABI (ERC20)
// ============================================
export const mbcTokenABI = parseAbi([
  // Functions
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function balanceOf(address account) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function decreaseAllowance(address spender, uint256 subtractedValue) returns (bool)",
  "function increaseAllowance(address spender, uint256 addedValue) returns (bool)",
  "function mint(address to, uint256 amount)",
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function totalSupply() view returns (uint256)",
  "function transfer(address to, uint256 amount) returns (bool)",
  "function transferFrom(address from, address to, uint256 amount) returns (bool)",
  // Events
  "event Approval(address indexed owner, address indexed spender, uint256 value)",
  "event Transfer(address indexed from, address indexed to, uint256 value)",
]);

// ============================================
// USDT Token ABI (ERC20)
// ============================================
export const usdtTokenABI = parseAbi([
  // Functions
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function decimals() view returns (uint8)",
  "function totalSupply() view returns (uint256)",
  "function balanceOf(address account) view returns (uint256)",
  "function transfer(address to, uint256 amount) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function transferFrom(address from, address to, uint256 amount) returns (bool)",
  "function increaseAllowance(address spender, uint256 addedValue) returns (bool)",
  "function decreaseAllowance(address spender, uint256 subtractedValue) returns (bool)",
  // Events
  "event Approval(address indexed owner, address indexed spender, uint256 value)",
  "event Transfer(address indexed from, address indexed to, uint256 value)",
]);

// ============================================
// Sanh Purchase ABI
// ============================================
export const sanhPurchaseABI = parseAbi([
  // Functions
  "function buySanh(string transactionId, uint256 sanhAmount, uint8 paymentToken)",
  "function commitTransaction(string transactionId)",
  "function currency() view returns (address)",
  "function estimateMBCBuySanh(uint256 sanhAmount) view returns (uint256 mbcAmount)",
  "function estimateUSDTBuySanh(uint256 sanhAmount) view returns (uint256 usdtAmount)",
  "function getTransaction(string transactionId) view returns ((address buyer, address currencyAddress, uint256 currencyAmount, uint8 status, uint256 createdAt, bool refunded))",
  "function initialize(address initialOwner, address initialCurrency)",
  "function markFailed(string transactionId)",
  "function mbcPerUsdt() view returns (uint256)",
  "function owner() view returns (address)",
  "function paymentReceiver() view returns (address)",
  "function proxiableUUID() view returns (bytes32)",
  "function refund(string transactionId)",
  "function renounceOwnership()",
  "function sanhPriceVnd() view returns (uint256)",
  "function setAllPrices(uint256 _mbcPerUsdt, uint256 _usdPerVnd, uint256 _sanhPriceVnd)",
  "function setMbcPerUsdt(uint256 _mbcPerUsdt)",
  "function setPaymentReceiver(address _receiver)",
  "function setSanhPriceVnd(uint256 _sanhPriceVnd)",
  "function setUsdPerVnd(uint256 _usdPerVnd)",
  "function transactions(string) view returns (address buyer, address currencyAddress, uint256 currencyAmount, uint8 status, uint256 createdAt, bool refunded)",
  "function transferOwnership(address newOwner)",
  "function transferToken(address token, address to, uint256 amount)",
  "function updateCurrency(address newCurrency)",
  "function upgradeTo(address newImplementation)",
  "function upgradeToAndCall(address newImplementation, bytes data) payable",
  "function usdPerVnd() view returns (uint256)",
  // Events
  "event AdminChanged(address previousAdmin, address newAdmin)",
  "event BeaconUpgraded(address indexed beacon)",
  "event CurrencyUpdated(address oldCurrency, address newCurrency)",
  "event Initialized(uint8 version)",
  "event OwnershipTransferred(address indexed previousOwner, address indexed newOwner)",
  "event PurchaseReceived(string indexed transactionId, address indexed buyer, address currency, uint256 amount)",
  "event Refunded(string indexed transactionId, uint256 amount)",
  "event TokenTransferred(address indexed token, address indexed to, uint256 amount)",
  "event TokenWhitelistUpdated(address indexed token, bool allowed)",
  "event TransactionCommitted(string indexed transactionId)",
  "event Upgraded(address indexed implementation)",
]);

// ============================================
// Sanh Marketplace ABI
// ============================================
export const sanhMarketplaceABI = parseAbi([
  // Functions
  "function buyNFTs(address[] nfts, uint256[] tokenIds, address[] sellers)",
  "function feeBasisPoints() view returns (uint96)",
  "function feeRecipient() view returns (address)",
  "function getAllListings() view returns ((address seller, address nft, uint256 tokenId, uint256 amount, uint256 price, bool isERC1155)[])",
  "function initialize(address initialOwner, address _feeRecipient, uint96 _feeBps, address _paymentToken)",
  "function listingKeys(uint256) view returns (uint256)",
  "function listingSanhs(address nft, uint256[] tokenIds, uint256 amount, uint256 price)",
  "function listings(uint256) view returns (address seller, address nft, uint256 tokenId, uint256 amount, uint256 price, bool isERC1155)",
  "function onERC1155BatchReceived(address, address, uint256[], uint256[], bytes) pure returns (bytes4)",
  "function onERC1155Received(address, address, uint256, uint256, bytes) pure returns (bytes4)",
  "function owner() view returns (address)",
  "function paymentToken() view returns (address)",
  "function proxiableUUID() view returns (bytes32)",
  "function renounceOwnership()",
  "function setFee(uint96 newFeeBps, address newRecipient)",
  "function setPaymentToken(address token)",
  "function transferOwnership(address newOwner)",
  "function unlistNFT(address nft, uint256 tokenId)",
  "function upgradeTo(address newImplementation)",
  "function upgradeToAndCall(address newImplementation, bytes data) payable",
  // Events
  "event AdminChanged(address previousAdmin, address newAdmin)",
  "event BeaconUpgraded(address indexed beacon)",
  "event Bought(address indexed buyer, address indexed seller, address indexed nft, uint256 tokenId, uint256 price, uint256 amount)",
  "event FeeUpdated(address recipient, uint96 basisPoints)",
  "event Initialized(uint8 version)",
  "event Listed(address indexed seller, address indexed nft, uint256 indexed tokenId, uint256 price, uint256 amount, bool isERC1155)",
  "event OwnershipTransferred(address indexed previousOwner, address indexed newOwner)",
  "event Unlisted(address indexed seller, address indexed nft, uint256 indexed tokenId)",
  "event Upgraded(address indexed implementation)",
]);

// ============================================
// NFT COLLECTION ABI
// ============================================
export const nftCollectionABI = parseAbi([
  // Functions
  "function supportsInterface(bytes4 interfaceId) view returns (bool)",
  "function balanceOf(address account, uint256 id) view returns (uint256)",
  "function balanceOfBatch(address[] accounts, uint256[] ids) view returns (uint256[])",
  "function setApprovalForAll(address operator, bool approved)",
  "function isApprovedForAll(address account, address operator) view returns (bool)",
  "function safeTransferFrom(address from, address to, uint256 id, uint256 amount, bytes data)",
  "function safeBatchTransferFrom(address from, address to, uint256[] ids, uint256[] amounts, bytes data)",
  // Events
  "event ApprovalForAll(address indexed account, address indexed operator, bool approved)",
  "event TransferBatch(address indexed operator, address indexed from, address indexed to, uint256[] ids, uint256[] values)",
  "event TransferSingle(address indexed operator, address indexed from, address indexed to, uint256 id, uint256 value)",
  "event URI(string value, uint256 indexed id)",
]);


// ============================================
// LuckyDraw ABI
// ============================================
export const luckyDrawABI = parseAbi([
  // Functions
  "function getTicketPrice() view returns (uint256)",
  "function getTicketPriceUSDT() view returns (uint256)",
  "function buyTicket(uint256 quantity) payable",
  "function awardPrize(address winner, uint256 amount, address token)",
  "function startNewRound()",
]);